/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

interface UiProbabilityPickerItemProps {
    p: number
    onClick: () => void
    colorClass: string
}

const UiProbabilityPickerItem: React.FC<UiProbabilityPickerItemProps> = ({
    p,
    onClick,
    colorClass,
}) => {
    return (
        <div
            onClick={onClick}
            className={clsx(
                'UiProbabilityPickerItem w-9 h-9 rounded-full flex items-center justify-center text-[10px] text-white font-bold cursor-pointer hover:scale-115 hover:shadow-lg transition-all shadow-sm',
                colorClass
            )}
        >
            {p}%
        </div>
    )
}

export default UiProbabilityPickerItem
